module.exports = __webpack_public_path__ + "static/media/Camera.3037d54e.svg";